module.exports = __webpack_public_path__ + "static/img/today_best_team_2.32fb6908.png";